import React from "react";
import { graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import Devis24h from "../../assets/icons/devis-sous-24_H.svg"
import Qualitegarantie from "../../assets/icons/qualite-garantie.svg"
import Echantillon from "../../assets/icons/echantillon.svg"
import Maquette from "../../assets/icons/maquette-virtuelle.svg"
import Livraison7 from "../../assets/icons/livraison.svg"
import LivraisonOfferte from "../../assets/icons/livraison-offerte.svg"
import France from "../../assets/icons/impression-francaise.svg"

const IconsLineCat = () => {

  const icons = [
    {
      src: <Devis24h height="64" />,
      text: "DEVIS SOUS 24H",
      alt: "DEVIS SOUS 24H",
    },
    {
      src: <Qualitegarantie height="64" />,
      text: <span>QUALITÉ<br />GARANTIE</span>,
      alt: "QUALITÉ GARANTIE",
    },
    {
      src: <Echantillon height="64" />,
      text: <span>POSSIBILITÉ D'ENVOI<br />D'ÉCHANTILLON</span>,
      alt: "POSSIBILITÉ D'ENVOI D'ÉCHANTILLON",
    },
    {
      src: <Maquette height="64" />,
      text: <span>MAQUETTE<br />VIRTUELLE</span>,
      alt: "MAQUETTE VIRTUELLE",
    },
    {
      src: <Livraison7 height="64" />,
      text: <span>LIVRAISON EN <br />7 JOURS OUVRÉS</span>,
      alt: "LIVRAISON EN 7 JOURS OUVRÉS",
    },
    {
      src: <LivraisonOfferte height="64" />,
      text: <span>LIVRAISON<br />OFFERTE</span>,
      alt: "LIVRAISON OFFERTE",
    },
    {
      src: <France height="64" />,
      text: "IMPRESSION FRANÇAISE",
      alt: "IMPRESSION FRANÇAISE",
    },
  ];

  return (
    <ul className="hidden md:grid md:grid-cols-7 list-none justify-between  ">
      {icons.map((icon, i) => (
        <li key={i} className="">
          <div className="flex justify-center items-center mb-4">
            {(icon.src)}
          </div>
          <div className="mb-0 text-sm font-bold text-gray-700 text-center">{icon.text}</div>
        </li>
      ))}
    </ul>
  );
};


export default IconsLineCat;
